import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { TagInputModule } from 'ngx-chips';

import { DateLocalePipe } from './pipe/date-locale.pipe';
import { DatetimeLocalePipe } from './pipe/datetime-locale.pipe';

import { SortableDirective } from './directive/sortable.directive';
import { NumbersOnlyDirective } from './directive/numbers-only.directive';
import { MobileNumberEncPipe } from './pipe/mobile-number-enc.pipe';

@NgModule({
  declarations: [DateLocalePipe, DatetimeLocalePipe, SortableDirective, NumbersOnlyDirective, MobileNumberEncPipe],
  imports: [CommonModule, ReactiveFormsModule, NgxPaginationModule, TagInputModule],
  exports: [
    ReactiveFormsModule,
    NgxPaginationModule,
    TagInputModule,
    DateLocalePipe,
    DatetimeLocalePipe,
    SortableDirective,
    NumbersOnlyDirective,
    MobileNumberEncPipe
  ]
})
export class SharedModule {}
